import React from "react";

const Services = () => {
  // services details
  const services = [
    {
      name: "Pomysł",
      desc: ["Pomagam znaleźć temat filmu oraz sposób pokazania Twojej firmy. ","Nie musisz mieć gotowego scenariusza ani doświadczenia przed kamerą."],
      icon: "fas fa-lightbulb",
    },
    {
      name: "Przygotowanie",
      desc: "Tworzę scenariusz, plan nagrań oraz organizuję przebieg całej realizacji. Podpowiadam jak się przygotować i dbam o każdy szczegół.",
      icon: "fas fa-check",
    },
    {
      name: "Realizacja",
      desc: ["Nagrywam materiały wideo z wykorzystaniem profesjonalnego sprzętu. Prowadzę nagrania tak, abyś czuł się swobodnie przed kamerą."],
      icon: "fas fa-video",
    },
    {
      name: "Postprodukcja",
      desc: "Łączę najlepsze ujęcia, dbam o tempo filmu, odpowiedni klimat i detale, dzięki którym całość wygląda profesjonalnie i angażuje odbiorców.",
      icon: "fas fa-desktop",
    },
    {
      name: "Publikacja",
      desc: "Materiały przygotowuję pod konkretne platformy społecznościowe oraz wybrane formaty. Otrzymujesz gotowy content do wykorzystania.",
      icon: "fas fa-upload",
    },
    {
      name: "Stała współpraca",
      desc: "Regularnie tworzę nowe materiały, dzięki którym Twoja firma pozostaje aktywna w internecie - budując zaufanie oraz profesjonalny wizerunek.",
      icon: "fas fa-handshake",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Czym się zajmuję?</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          Kompleksowe wsparcie dla Twojej marki
        </h2>
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
